import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { RadioButton, type RadioButtonSize, type RadioButtonState } from './RadioButton';

export interface RadioButtonListOption {
  value: string;
  label: string;
  description?: string;
}

export interface RadioButtonListProps {
  options: RadioButtonListOption[];
  selectedValue?: string;
  size?: RadioButtonSize;
  state?: RadioButtonState;
  onChange?: (value: string) => void;
}

export function RadioButtonList({
  options,
  selectedValue,
  size = 'small',
  state = 'enabled',
  onChange,
}: RadioButtonListProps) {
  const listWidth = size === 'large' ? 131 : 119;

  return (
    <Column width={listWidth} paddingVertical="spacing.general.x4" gap="spacing.general.x4">
      {options.map((option) => (
        <RadioButton
          key={option.value}
          size={size}
          state={state}
          label={option.label}
          description={option.description}
          showDescription={Boolean(option.description)}
          selected={selectedValue === option.value}
          onPress={() => onChange?.(option.value)}
        />
      ))}
    </Column>
  );
}
